import clsx from 'clsx'
import type { ReactNode } from 'react'
import { Tooltip } from '../../Elements/Tooltip/Tooltip'
import {
  metaItem,
  metaItemContent,
  metaItemRight,
  metaItemTitle
} from './Card.css'

export type MetaItemProps = {
  children: ReactNode
  title?: string
  tooltip?: string
  align?: 'left' | 'right'
}

export const MetaItem = ({
  children,
  title,
  tooltip,
  align = 'left'
}: MetaItemProps) => {
  return (
    <div className={clsx(metaItem, align === 'right' && metaItemRight)}>
      {title && tooltip && (
        <Tooltip text={tooltip} asChild direction="top">
          <span className={metaItemTitle}>{title}</span>
        </Tooltip>
      )}
      {title && !tooltip && <span className={metaItemTitle}>{title}</span>}
      <div className={metaItemContent}>{children}</div>
    </div>
  )
}
